<template>
  <div id="app">
    <vue-nav ref="navbar" :seethroughpage="navsetting"></vue-nav>
    <main id="main-page-content">
      <router-view @navsetting="handle" class="mb-5" ></router-view> 
    </main>
    <footer class="pb-5 bg-dark">
      <slanted-section-border
        class="section-border-top"
        transform="scale(1,-1) translate(0,-100)"
        fill="#363636"
      ></slanted-section-border>
      <b-container class="text-light text-center">
        <div class="footer-copyright">
          <p>
            © 2020 Copyright @
            <strong class="text-primary">Wout Knuiman</strong>
          </p>
        </div>
      </b-container>
    </footer>
  </div>
</template>

<script>
import VueNav from "@/layout/VueNav"
import SlantedSectionBorder from "@/components/svg/SlantedSectionBorder";

export default {
  components:{
    VueNav,
    SlantedSectionBorder
  },
  methods:{
    handle(navsetting){
      this.$refs.navbar.setSeethrough(navsetting);
      this.navsetting = navsetting;
    }
  },
  data(){
    return{
      navsetting: window.location.pathname == "/",
    }
  }
}
</script>

<style lang="scss">


* {
  outline: 0px !important;
}

.hero-body {
  display: flex;
  align-items: center;
  text-align: center;
  position: relative;
  top: 0;
  background: rgba(0, 0, 0, 0.5);
  width: 100%;
  height: 100%;
  padding: 20px;
}

.hero {
  height: 70vh;
}

.text-container {
  max-width: 600px;
}

.section-border-top {
  position: absolute;
  transform: translateY(-99.9%);
}

.section-border-bottom {
  position: absolute;
}

#main-page-content {
  flex: 1 1;
}

#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

</style>